// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = "/auth";
const ROOTS_DASHBOARD = "/dashboard";
const ROOTS_INVOICE = "/invoice";
const ROOTS_COST = "/cost";
const ROOTS_REPORT = "/report";
const ROOTS_TASK = "/task";
const ROOTS_MANUFACTURE = "/manufacture";
const ROOTS_INVENTORY = "/inventory";
const ROOTS_PRODUCT = "/product";
const ROOTS_LEADER = "/lead";
const ROOTS_MASTER = "/master";
const ROOT_STOCK = "/stock";
const ROOT_PRICE_CALCULATOR = "/price-calculator";

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, "/login"),
  loginUnprotected: path(ROOTS_AUTH, "/login-unprotected"),
  registerUnprotected: path(ROOTS_AUTH, "/register-unprotected"),
};

export const PATH_PAGE = {
  comingSoon: "/coming-soon",
  maintenance: "/maintenance",
  payment: "/payment",
  about: "/about-us",
  contact: "/contact-us",
  faqs: "/faqs",
  page404: "/404",
  page500: "/500",
  components: "/components",
  confirmationorder: `/confirmation-order/orderId`,
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    app: path(ROOTS_DASHBOARD, "/app"),
    ecommerce: path(ROOTS_DASHBOARD, "/ecommerce"),
    analytics: path(ROOTS_DASHBOARD, "/analytics"),
    banking: path(ROOTS_DASHBOARD, "/banking"),
    booking: path(ROOTS_DASHBOARD, "/booking"),
  },
  master: {
    root: ROOTS_MASTER,
    user: path(ROOTS_MASTER, "/user/list"),
    userProfile: path(ROOTS_MASTER, "/user/profile"),
    userProfileId: (id) => path(ROOTS_MASTER, `/user/${id}/profile`),
    store: path(ROOTS_MASTER, "/store"),
    design: path(ROOTS_MASTER, "/design-master"),
    workshop: path(ROOTS_MASTER, "/workshop"),
  },
  invoice: {
    root: ROOTS_INVOICE,
    list: path(ROOTS_INVOICE, "/list/:tab/page-:pages"),
    newCustomer: path(ROOTS_INVOICE, "/customer/new"),
    // priceCalculation: path(ROOTS_INVOICE, "/price-calculator"),
    // featuresItem: path(ROOTS_INVOICE, "/price-calculator/features"),
  },

    pricecalculator: {
    root: ROOT_PRICE_CALCULATOR, 
    preview: path(ROOT_PRICE_CALCULATOR, "/preview"),
    featuresItem: path(ROOT_PRICE_CALCULATOR, "/features"),

  },
  manufacture: {
    root: ROOTS_MANUFACTURE,
    list: path(ROOTS_MANUFACTURE, "/list"),
    remakelist: path(ROOTS_MANUFACTURE, "/remakelist"),
    resizelist: path(ROOTS_MANUFACTURE, "/resizelist"),
    repairlist: path(ROOTS_MANUFACTURE, "/repairlist"),
    mastercardlist: path(ROOTS_MANUFACTURE, "/master-card-list"),
    notification: path(ROOTS_MANUFACTURE, "/notification-list"),
    notificationId: (id) => path(ROOTS_MANUFACTURE, `/notification/${id}/view`),
  },
  inventory: {
    root: ROOTS_INVENTORY,
    // Lab Grown paths
    labgrown: {
      root: path(ROOTS_INVENTORY, "/lab-grown"),
      diamond: path(ROOTS_INVENTORY, "/lab-grown/diamond"),
      gemstone: path(ROOTS_INVENTORY, "/lab-grown/gemstone"),
      mount: path(ROOTS_INVENTORY, "/lab-grown/mount"),
      finishring: path(ROOTS_INVENTORY, "/lab-grown/finish-ring"),
      earrings: path(ROOTS_INVENTORY, "/lab-grown/earrings"),
      pendants: path(ROOTS_INVENTORY, "/lab-grown/pendants"),
      bracelet: path(ROOTS_INVENTORY, "/lab-grown/bracelet"),
    },
    // Natural paths
    natural: {
      root: path(ROOTS_INVENTORY, "/natural"),
      diamond: path(ROOTS_INVENTORY, "/natural/diamond"),
      gemstone: path(ROOTS_INVENTORY, "/natural/gemstone"),
      mount: path(ROOTS_INVENTORY, "/natural/mount"),
      finishring: path(ROOTS_INVENTORY, "/natural/finish-ring"),
      earrings: path(ROOTS_INVENTORY, "/natural/earrings"),
      pendants: path(ROOTS_INVENTORY, "/natural/pendants"),
      bracelet: path(ROOTS_INVENTORY, "/natural/bracelet"),
    },
  },
  report: {
    root: ROOTS_REPORT,
    // invoice report paths
    invoice: {
      root: path(ROOTS_REPORT, "/invoice"),
      daily: path(ROOTS_REPORT, "/invoice/daily"),
      monthly: path(ROOTS_REPORT, "/invoice/monthly"),
      annual: path(ROOTS_REPORT, "/invoice/annual"),
    },
    // payment report paths
    paymentReport: {
      root: path(ROOTS_REPORT, "/payment"),
      daily: path(ROOTS_REPORT, "/payment/daily"),
      monthly: path(ROOTS_REPORT, "/payment/monthly"),
      annual: path(ROOTS_REPORT, "/payment/annual"),
    },
    // Leaderboard paths
    leaderboard: {
      root: path(ROOTS_REPORT, "/leaderboard"),
      daily: path(ROOTS_REPORT, "/leaderboard/daily"),
      monthly: path(ROOTS_REPORT, "/leaderboard/monthly"),
      annual: path(ROOTS_REPORT, "/leaderboard/annual"),
      calendar: path(ROOTS_REPORT, "/leaderboard/calendar"),
    },
    // cost report paths
    costReport: {
      root: path(ROOTS_REPORT, "/cost"),
      monthly: path(ROOTS_REPORT, "/cost/all-months"),
      annual: path(ROOTS_REPORT, "/cost/annual"),
    },
    // data report paths
    dataReport: {
      root: path(ROOTS_REPORT, "/data"),
      daily: path(ROOTS_REPORT, "/data/daily"),
      monthly: path(ROOTS_REPORT, "/data/monthly"),
      annual: path(ROOTS_REPORT, "/data/annual"),
      engagementRing: path(ROOTS_REPORT, "/data/engagement-ring"),
    },
  },
  lead: {
    root: ROOTS_LEADER,
    newLeader: path(ROOTS_LEADER, "/add"),
    allLead: path(ROOTS_LEADER, "/all"),
    leadcalender: path(ROOTS_LEADER, "/calendar"),
  },
  cost: {
    root: ROOTS_COST,
    postProd: path(ROOTS_COST, "/post-production"),
    expense: path(ROOTS_COST, "/expenses"),
  },
  task: {
    root: ROOTS_TASK,
    invoiceTask: path(ROOTS_TASK, "/invoice"),
    balanceReminder: path(ROOTS_TASK, "/balance-reminder"),
    workshopTask: path(ROOTS_TASK, "/workshop"),
  },
  stock: {
    root: ROOT_STOCK,
    list: path(ROOT_STOCK, "/list"),
    newStock: path(ROOT_STOCK, "/new"),
  },
  product: {
    root: ROOTS_PRODUCT,
    list: path(ROOTS_PRODUCT, "/list"),
  },
};
